module.exports = __webpack_public_path__ + "f93f877b0b734b741e91b0783e4ff6e8.pdf";